import Button from 'apollo-react/components/Button';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { parseNavigationColumnParams } from '../../utils/legacyRouteMapper';

const SignUpButtonCell = ({ row }) => {
  const translateString = useTranslation();
  const history = useHistory();

  const onClickHandler = () => {
    const link = parseNavigationColumnParams(row.NavigationColumnParams, true);
    history.push(link);
  };

  return (
    <span ui-ta={getUITA('SavedSearch', 'SignUpButton')}>
      <Button color="primary" variant="primary" size="small" onClick={onClickHandler}>
        {translateString('SignUp')}
      </Button>
    </span>
  );
};

export default SignUpButtonCell;
